import React, { useState } from "react";
import "./ChangePasswordModal.css";

const ChangePasswordModal = ({ isOpen, onClose, onChangePassword }) => {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");

    const handleClose = () => {
        setCurrentPassword("");
        setNewPassword("");
        setConfirmNewPassword(""); // Reset confirm password field as well
        onClose();
    };

    const handleSubmit = () => {
        if (!currentPassword || !newPassword || !confirmNewPassword) {
            alert("모든 필드를 입력해주세요.");
            return;
        }
        if (newPassword !== confirmNewPassword) {
            alert("새 비밀번호가 일치하지 않습니다.");
            return;
        }
        onChangePassword(currentPassword, newPassword);
        handleClose();
    };

    if (!isOpen) return null;

    return (
        <div className="change-password-modal-overlay">
            <div className="change-password-modal-content">
                <div className="change-password-modal-title">비밀번호 변경</div>
                <label>현재 비밀번호</label>
                <input
                    type="password"
                    placeholder="현재 비밀번호를 입력해주세요"
                    value={currentPassword}
                    onChange={(e) => setCurrentPassword(e.target.value)}
                />
                <label>새 비밀번호</label>
                <input
                    type="password"
                    placeholder="새 비밀번호를 입력해주세요"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <label>새 비밀번호 확인</label>
                <input
                    type="password"
                    placeholder="새 비밀번호를 다시 입력해주세요"
                    value={confirmNewPassword}
                    onChange={(e) => setConfirmNewPassword(e.target.value)}
                />
                <div className="change-password-modal-buttons">
                    <button onClick={handleClose}>취소</button>
                    <button onClick={handleSubmit}>비밀번호 변경</button>
                </div>
            </div>
        </div>
    );
};

export default ChangePasswordModal;
